import { _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';
import { ExtractedDocumentItem } from '@/_types/models/documents';

export const deletePath = async ({
  path,
  companyId,
  token,
}: APIRequest<{
  path: string;
  companyId: number;
}>): APIResponsePromise =>
  await _callBackend(
    '/integrations/delete_path',
    'POST',
    { path, company_id: companyId },
    token,
  );

export const getDocumentsUploadedOutsideOfQuestionnaire = async ({
  companyId,
  from3MonthsAgo,
  token,
}: APIRequest<{
  companyId: number;
  from3MonthsAgo?: boolean;
}>): APIResponsePromise =>
  await _callBackend(
    `/integrations/get_documents_uploaded_outside_of_questionnaire?company_id=${companyId}&from_3_months_ago=${from3MonthsAgo}`,
    'GET',
    null,
    token,
  );

export const handleOneSchemaSuccess = async ({
  data,
  token,
}: APIRequest<{
  data: any;
}>): APIResponsePromise =>
  await _callBackend(
    '/integrations/handle_one_schema_success',
    'POST',
    { data },
    token,
  );

export const getExtractedDocumentByPath = async ({
  companyId,
  path,
  token,
}: APIRequest<{
  companyId: number;
  path: string;
}>): APIResponsePromise<{ document: ExtractedDocumentItem }> =>
  await _callBackend(
    `/integrations/get_extracted_document_by_path?company_id=${companyId}&path=${path}`,
    'GET',
    null,
    token,
  );

export const checkSharepointIntegration = async ({
  token,
}: APIRequest): APIResponsePromise<{
  connected: boolean;
  firm_connected: boolean;
  firm_has_sharepoint: boolean;
  expiring_soon_in: string | false | null;
}> =>
  await _callBackend(
    '/integrations/check_sharepoint_integration',
    'GET',
    null,
    token,
  );
